/**
 * Stable CSS class names for E2E — StoreList page.
 * Used by the test automation team as deterministic selectors.
 * Containers use `store-list__<element>`; inputs and user-interactable
 * controls use `store-list-input--<name>`.
 */
export const STL = {
    page: 'store-list-page',
    root: 'store-list',

    header: 'store-list__header',
    title: 'store-list__title',

    drawer: 'store-list__drawer',
    drawerContent: 'store-list__drawer-content',

    grid: 'store-list__grid',

    cellStoreCode: 'store-list__cell-store-code',
    cellStoreName: 'store-list__cell-store-name',
    cellEmail: 'store-list__cell-email',
    cellAddress: 'store-list__cell-address',
    cellCity: 'store-list__cell-city',
    cellDistrict: 'store-list__cell-district',
    cellEdit: 'store-list__cell-edit',
    btnEdit: 'store-list-input--button-edit',
} as const;

export const stlCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
